// Backend-sourced enums — canonical definitions now live in src/api/.
// Re-exported here for backward compatibility during migration. Once Redux
// slices are converted to TypeScript, consumers should import from the slice
// (or directly from src/api/) rather than from here.
export {
  AffiliationStatus,
  ApplicationStatus,
  ApplicationType,
  AttachmentPreferences,
  EmailFailureCode,
  QuestionType,
  RuleFailureMode,
  TeamType,
} from '../api/user-affiliations';
export { GuidelinesFormat } from '../api/community';

export enum ApplicationErrors {
  NO_ERROR = 'NO_ERROR',
}

export enum AffiliationErrorCodes {
  ALREADY_AFFILIATED = 'ALREADY_AFFILIATED',
  APPLICATION_IN_PROGRESS = 'APPLICATION_IN_PROGRESS',
  APPLICATION_RENEWAL = 'APPLICATION_RENEWAL',
  GENERIC = 'GENERIC',
  MEMBER_NUMBER_INVALID = 'MEMBER_NUMBER_INVALID',
  MEMBER_NUMBER_TAKEN = 'MEMBER_NUMBER_TAKEN',
  NOT_FOUND = 'NOT_FOUND',
  NO_LONGER_VALID = 'NO_LONGER_VALID',
  PUBLIC_SIGNUP_NOT_ALLOWED = 'PUBLIC_SIGNUP_NOT_ALLOWED',
  RENEWAL_INACTIVE_AFFILIATION = 'RENEWAL_INACTIVE_AFFILIATION',
  RENEWAL_NO_AFFILIATION = 'RENEWAL_NO_AFFILIATION',
  RENEWAL_OUTSIDE_WINDOW = 'RENEWAL_OUTSIDE_WINDOW',
  REQUIRED_ANSWERS_MISSING = 'REQUIRED_ANSWERS_MISSING',
  RETAIL_LOCATION_CHANGE = 'RETAIL_LOCATION_CHANGE',
}

/**
 * Group Search Form Modes
 */
export enum GroupSearchFormModes {
  GROUP_CODE = 'groupCode',
  SEARCH = 'search',
}

/**
 * Initial Page Form Modes
 */
export enum InitialFormModes {
  PRE_AUTHENTICATED = 'preAuthenticated',
  SIGN_IN = 'signIn',
  SIGN_UP = 'signUp',
  SPLASH = 'splash',
}

export enum Layout {
  INTEREST = 'interests',
  MANAGE = 'manage',
  MODAL = 'modal',
  POST_AFFILIATION = 'qualify',
  QUALIFY = 'qualify',
  SETUP = 'setup',
  STATIC = 'static',
}
